<seds-core-button
  [ngClass]="{ 'button-pointer-events': disabled }"
  [title]="title"
  [disabled]="disabled"
  [iconName]="iconName"
  [color]="colors[color]"
  [iconPosition]="iconPosition"
  [type]="type"
  [size]="size"
  [loading]="loading"
  [width]="width"></seds-core-button>
